import liveActivityService from 'common/services/live-activity-service/live-activity-service';
import { ILiveActivity } from 'features/eiq-secure/stores/live-activity/live-activity.types';
import { makeAutoObservable, runInAction } from 'mobx';

class EIQManageLiveActivityStore {
  private liveActivityLogs: ILiveActivity[];
  private location: string | null;

  constructor() {
    this.liveActivityLogs = [];
    this.location = null;

    makeAutoObservable(this);
  }

  async init() {
    const result = await liveActivityService.getLastLiveActivityByGate();
    runInAction(() => {
      this.liveActivityLogs = [...result];
    });
  }

  setLocation(location: string | null) {
    this.location = location;
  }

  addRecord(log: ILiveActivity) {
    const exists = this.liveActivityLogs.some((i) => i.id === log.id);
    if (exists) {
      return;
    }

    if (this.liveActivityLogs.length >= 300) {
      this.liveActivityLogs.pop();
    }
    this.liveActivityLogs.unshift(log);
  }

  get logs() {
    if (this.location) {
      return this.liveActivityLogs.filter((i) => i.gate === this.location);
    }

    return this.liveActivityLogs;
  }
}

const eiqManageLiveActivityStore = new EIQManageLiveActivityStore();
export default eiqManageLiveActivityStore;
